<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          <v-chip
            label
            class="m-r-10"
            small
            color="orange"
          >
            {{ mediaSource.type }}
          </v-chip>
          {{ mediaSource.name | truncate(50) }}
          <span class="p-l-10 text-body-2 text-right grey--text">
            last scan time: {{ moment.utc(mediaSource.lastImportTime2).from(moment().utc()) }}
          </span>
          <v-spacer />
          <v-spacer />
          <v-spacer />
          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-card-subtitle>
          <i class="fas fa-link p-r-10" />
          <a
            :href="mediaSource.url"
            target="_blank"
          >{{ mediaSource.url }}</a>
        </v-card-subtitle>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="mrssItems"
          item-key="id"
          class="elevation-1 table-one pointer"
          multi-sort
          :items-per-page="20"
          :footer-props="{
            'items-per-page-options': [20, 40, 80, 100],
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
          }"
          @click:row="openItem"
        >
          <template v-slot:item.id="{item}">
            <div class="d-flex align-center">
              <p class="ma-0 font-weight-medium">
                {{ item.id }}
              </p>
            </div>
          </template>
          <template v-slot:item.name="{item}">
            <div class="d-flex align-center">
              <v-avatar
                class="mr-2"
                size="26"
                dark
                tile
              >
                <img
                  :src="item.pictureURL"
                  alt=""
                >
              </v-avatar>
              <p class="ma-0 font-weight-medium">
                {{ item.name }}
              </p>
            </div>
          </template>
          <template v-slot:item.createTime="{item}">
            <div class="d-flex align-center">
              {{ moment.utc(item.createTime).format('D MMM YY') }}
            </div>
          </template>
          <template v-slot:item.action="{item}">
            <div class="d-flex" />
          </template>
          <template v-slot:item.state="{item}">
            <template v-if="item.state === 'transcoded'">
              <v-chip
                class=""
                color="success"
                label
                small
                text-color="white"
              >
                <v-icon
                  small
                  left
                >
                  mdi-check
                </v-icon>
                {{ item.state }}
              </v-chip>
            </template>
            <template v-else-if="item.state === 'transcoding'">
              <v-chip
                class=""
                color="success"
                label
                small
                text-color="white"
              >
                <v-icon
                  small
                  left
                  class="fa-spin"
                >
                  fa fa-circle-notch
                </v-icon>
                {{ item.state }}
              </v-chip>
            </template>
            <template v-else-if="item.state === 'new' || item.state === 'pending'">
              <v-chip
                class=""
                color="orange"
                label
                small
                text-color="white"
              >
                <v-icon
                  small
                  left
                >
                  mdi-dot
                </v-icon>
                {{ item.state }}
              </v-chip>
            </template>
            <template v-else>
              <v-chip
                class=""
                color="error"
                label
                small
                text-color="white"
              >
                <v-icon
                  small
                  left
                >
                  mdi-close
                </v-icon>
                {{ item.state }}
              </v-chip>
            </template>
          </template>
        </v-data-table>
      </base-card>
    </v-col>
    <!-- Item -->
    <v-dialog
      v-model="itemDialog"
      max-width="1024px"
    >
      <v-card :loading="itemLoading">
        <v-card-title>
          <span class="text-h5">Item details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <h6>Source</h6>
                <v-sheet
                  id="scroll-area-1"
                  class="overflow-y-auto"
                  max-height="600"
                >
                  <pre class="text-body-2">{{ selectedItem.source }}</pre>
                </v-sheet>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <h6>Parse result</h6>
                <v-sheet
                  id="scroll-area-2"
                  class="overflow-y-auto"
                  max-height="600"
                >
                  <pre class="text-body-2">
                  {{ selectedItem.asset }}
                  </pre>
                </v-sheet>
                <p v-if="selectedItem.error">
                  Error:
                  {{ selectedItem.error }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="itemDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { processMediaSource, processChannel } from '@/store/converters'

  export default {
    data () {
      return {
        search: '',
        headers: [
          {
            text: 'ID',
            align: 'start',
            value: 'id',
          },
          {
            text: 'Item name',
            sortable: false,
            value: 'name',
          },
          { text: 'Categories', value: 'categories', sortable: false },
          { text: 'Add Date', value: 'createTime' },
          { text: 'Status', value: 'state' },
          { text: 'Action', value: 'action', sortable: false },
        ],
        mrssItems: [],
        mediaSource: {},
        itemDialog: false,
        selectedItem: {
          source: {},
          error: '',
        },
        itemLoading: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      channel () {
        if (this.$store.getters.channel) {
          return processChannel(this.$store.getters.channel)
        }
        return {}
      },
    },
    created () {
      const sourceId = this.$route.params.source_id
      this.loadData(sourceId)
    },
    methods: {
      loadData (id) {
        this.$store.commit('setPageLoader')

        const args = {
          $expand: 'mrss_items',
          $orderby: '-id',
          'id[eq]': id,
        }

        const mediaSourcesReq = this.$store.dispatch('mediaSources', args)

        return Promise.all([mediaSourcesReq])
          .then((res) => {
            const mediaSources = res[0]
            if (mediaSources.length === 0) {
              this.$router.push({
                name: 'MediaSourcesPage',
              })
              return
            }
            this.mediaSource = processMediaSource(mediaSources[0])

            if (mediaSources[0].mrss_items) {
              const mrssItems = []
              for (let i = 0; i < mediaSources[0].mrss_items.length; i += 1) {
                const item = mediaSources[0].mrss_items[i]
                const asset = item.asset || {}
                let pictureURL = ''
                if (asset.Pictures && asset.Pictures.length > 0) {
                  pictureURL = asset.Pictures[0]
                }
                const categories = asset.Categories || []
                mrssItems.push({
                  id: item.id,
                  name: item.name,
                  state: item.state,
                  createTime: item.create_time,
                  categories: categories.join(', '),
                  pictureURL: pictureURL,
                  asset: asset,
                  error: item.error,
                })
              }
              this.mrssItems = mrssItems
            }
          })
          .catch((errorMsg) => {
            this.$router.push({
              name: 'MediaSourcesPage',
            })
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      goToEditAsset (asset) {
        this.$router.push({
          name: 'AssetEditPage',
          params: {
            id: this.channel.id,
            asset_id: asset.id,
          },
        })
      },
      goToAsset (asset) {
        this.$router.push({
          name: 'AssetDetailPage',
          params: {
            id: this.channel.id,
            asset_id: asset.id,
          },
        })
      },
      goToEditMediaSource () {
        this.$router.push({
          name: 'AutoSourceEditPage',
          params: {
            id: this.channel.id,
            source_id: this.mediaSource.id,
          },
        })
      },
      playStreamByURL (stream, name, description) {
        const link = stream.replace(/^http:\/\//, 'https://')

        this.player.assetName = name
        this.player.assetDescription = description
        this.frameSrc = `/js/radiant/index2.html?src=${link}`
        this.openPlayer = true
      },
      closeStream () {
        this.openPlayer = false
        this.frameSrc = '/js/radiant/index.html?src='
      },
      openItem (item) {
        this.itemDialog = true
        this.selectedItem = item
        this.itemLoading = true

        this.selectedItem.error = item.error

        const args = {
          sourceId: this.mediaSource.id,
          itemId: item.id,
        }
        const itemReq = this.$store.dispatch('getMRSSItem', args)

        return Promise.all([itemReq])
          .then((res) => {
            if (res && res.length && res != '') {
              this.selectedItem.source = this.removeEmpty(res[0].Item)
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => this.itemLoading = false)
      },
      removeEmpty (obj) {
        const newObj = {}
        Object.entries(obj).forEach(([k, v]) => {
          if (v === Object(v)) {
            newObj[k] = this.removeEmpty(v)
          } else if (v !== '') {
            newObj[k] = obj[k]
          }
        })
        return newObj
      },
    },
  }
</script>

<style>
</style>
